import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { api_url, environment } from "../config.js";

const fake_token =
  "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOi9hay5leGFtcGxlLmNvbS9hdXRoL3JlYWxttV7Y3cskztDZqqmQI";

export const getSystemVersion = createAsyncThunk(
  "system/getVersion",
  async (_, { rejectWithValue }) => {
    const keycloak = JSON.parse(localStorage.getItem("keycloak") || "{}");
    const token =
      environment === "production-no-auth" ? fake_token : keycloak?.token;

    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    try {
      const { data } = await axios.get(`${api_url}/system/version`, config);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail ||
          "Error: Fetching system version failed.",
      );
    }
  },
);

const systemSlice = createSlice({
  name: "system",
  initialState: {
    backendVersionData: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSystemVersion.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSystemVersion.fulfilled, (state, action) => {
        state.loading = false;
        state.backendVersionData = action.payload;
      })
      .addCase(getSystemVersion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default systemSlice.reducer;
